import Nav from './nav';
import NavItem from './item';
import SubNav from './sub-nav';
import './styles/index.scss';
const ExpandedNav = Nav;
ExpandedNav.displayName = 'Nav';
ExpandedNav.Item = NavItem;
ExpandedNav.SubNav = SubNav;
export default ExpandedNav;
